const SeminarStateEnum = Object.freeze({
    PUBLIC: { value: 'release', text: '公開中' },
    PRIVATE: { value: 'private', text: '非公開' },
    END: { value: 'end', text: '終わり' },
});

export default SeminarStateEnum;
